/**
 * Config Actions
 */

import { SET_ORDER_SUPPORT_CONFIG, SET_ORDER_SUPPORT_CHECKLISTS } from 'Actions/types';
export const setOrderSupportConfig = data => async dispatch => {
  dispatch({
    type: SET_ORDER_SUPPORT_CONFIG,
    payload: data,
  });
};

export const setOrderSupportCheckList = data => async dispatch => {
  dispatch({
    type: SET_ORDER_SUPPORT_CHECKLISTS,
    payload: data,
  });
};
